import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'devices',
    props: true,
    meta: {
      middleware: [loggedIn]
    },
    component: () => import(/* webpackChunkName: "apps" */ './page.vue'),
    children: [
      {
        path: ':id',
        name: 'devicesTableComponent',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "appTableComponent" */ './item/index.vue'
          ),
        meta: {
          rootRouteName: 'devices'
        }
      },
      {
        path: ':id/:nestedId',
        name: 'devicesNestedComponent',
        props: true,
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  }
];
